import axios from '../axios'

const deleteAvailableApi = async (eventId) => {
    return await axios.delete(`api/teacher/events/${eventId}`)
}

export default deleteAvailableApi